(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const config = JSON.parse($('[data-hp-product]').textContent);
    const variants = config.variants || [];
    const currency = config.currency || 'USD';
    const labels = config.labels;
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
    const shopRoot = window.Shopify?.routes?.root || '/';
    const gallery = $('.hp-slides');
    const thumbs = $$('.hp-thumb');
    let activeSlide = 0;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function slideTo(i) {
      i = (i + thumbs.length) % thumbs.length;
      gallery.scrollTo({ left: i * gallery.clientWidth, behavior: reduced ? 'instant' : 'smooth' });
    }
    gallery.addEventListener('scroll', () => {
      activeSlide = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === activeSlide); thumb.setAttribute('aria-pressed', String(i === activeSlide)); });
      $('[data-gallery-counter]').textContent = `${activeSlide + 1} / ${thumbs.length}`;
    }, { passive: true });
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => slideTo(i)));
    $('[data-gallery-prev]').addEventListener('click', () => slideTo(activeSlide - 1));
    $('[data-gallery-next]').addEventListener('click', () => slideTo(activeSlide + 1));
    gallery.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); slideTo(activeSlide + (event.key === 'ArrowRight' ? 1 : -1)); } });
    new ResizeObserver(() => gallery.scrollTo({ left: activeSlide * gallery.clientWidth, behavior: 'instant' })).observe(gallery);
    const message = $('.hp-form-message');
    const subscription = $('[data-subscription]');
    let selectedIndex = 1;
    let sellingPlan = null;
    function getPlan(variant = variants[selectedIndex]) {
      const allocations = variant?.selling_plan_allocations || [];
      const groups = config.plans || [];
      const kaching = groups.filter(group => group.app_id === 'kaching_subscriptions');
      const plans = (kaching.length ? kaching : groups).flatMap(group => group.selling_plans || []);
      return allocations.find(allocation => plans.some(plan => String(plan.id) === String(allocation.selling_plan_id))) || null;
    }
    function updateOffer() {
      const variant = variants[selectedIndex];
      const radio = $(`input[name="hp-bundle"][value="${selectedIndex}"]`);
      let cents = variant ? variant.price : Math.round(Number(radio.dataset.price) * 100);
      $('[data-variant-id]').value = variant?.id || '';
      if (subscription.checked) {
        const allocation = getPlan();
        if (!allocation) { subscription.checked = false; sellingPlan = null; message.textContent = labels.subscription; }
        else { sellingPlan = allocation.selling_plan_id; cents = allocation.price; message.textContent = ''; }
      } else { sellingPlan = null; message.textContent = ''; }
      const planInput = $('[data-selling-plan]');
      planInput.value = sellingPlan || '';
      planInput.disabled = !sellingPlan;
      $('[data-button-price]').textContent = money(cents);
      $$('.hp-offer').forEach((offer, index) => {
        offer.classList.toggle('is-selected', index === selectedIndex);
        const input = offer.querySelector('input[name="hp-bundle"]');
        const bundle = variants[index];
        const allocation = getPlan(bundle);
        const bundlePrice = subscription.checked && allocation ? allocation.price : bundle ? bundle.price : Math.round(Number(input.dataset.price) * 100);
        offer.querySelector('[data-offer-price]').textContent = money(bundlePrice);
        const savings = offer.querySelector('[data-offer-savings]');
        savings.textContent = subscription.checked ? savings.dataset.savingsSubscription : savings.dataset.savingsOneTime;
      });
    }
    $$('input[name="hp-bundle"]').forEach(input => input.addEventListener('change', () => { selectedIndex = Number(input.value); message.textContent = ''; updateOffer(); }));
    subscription.addEventListener('change', updateOffer);
    if (variants.length) updateOffer();
    const shipDate = new Date(); shipDate.setDate(shipDate.getDate() + 1);
    $('[data-ship-date]').textContent = shipDate.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    const durationSeconds = 12 * 60 * 60;
    const countdownStartedAt = Date.now();
    const tick = () => {
      const elapsedSeconds = Math.max(0, Math.floor((Date.now() - countdownStartedAt) / 1000));
      const remaining = durationSeconds - elapsedSeconds % durationSeconds;
      const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      $('[data-hours]').textContent = hours;
      $('[data-minutes]').textContent = minutes;
      $('[data-seconds]').textContent = seconds;
      $('[data-stock-countdown]').textContent = `${hours}:${minutes}:${seconds}`;
    };
    setInterval(tick, 1000);
    tick();
    const resultsTrack = $('.hp-proof-grid');
    const resultsBar = $('.hp-proof-scrollbar');
    const resultsRange = $('.hp-proof-range');
    const syncResultsBar = () => {
      const maxScroll = Math.max(0, resultsTrack.scrollWidth - resultsTrack.clientWidth);
      resultsBar.hidden = maxScroll < 2;
      resultsRange.disabled = maxScroll < 2;
      resultsRange.value = maxScroll ? Math.round(Math.max(0, resultsTrack.scrollLeft) / maxScroll * 1000) : 0;
      resultsRange.style.setProperty('--hp-thumb-width', `${Math.max(30, resultsRange.clientWidth * resultsTrack.clientWidth / Math.max(1, resultsTrack.scrollWidth))}px`);
    };
    resultsTrack.addEventListener('scroll', syncResultsBar, { passive: true });
    resultsRange.addEventListener('input', () => {
      resultsTrack.style.scrollSnapType = 'none';
      resultsTrack.scrollTo({ left: Number(resultsRange.value) / 1000 * (resultsTrack.scrollWidth - resultsTrack.clientWidth), behavior: 'instant' });
    });
    resultsRange.addEventListener('change', () => { resultsTrack.style.scrollSnapType = ''; });
    resultsTrack.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const left = event.key === 'Home' ? 0 : event.key === 'End' ? resultsTrack.scrollWidth : resultsTrack.scrollLeft + (event.key === 'ArrowRight' ? 1 : -1) * resultsTrack.clientWidth * .9;
      resultsTrack.scrollTo({ left, behavior: reduced ? 'instant' : 'smooth' });
    });
    new ResizeObserver(syncResultsBar).observe(resultsTrack);
    syncResultsBar();
    const planList = (config.plans || []).flatMap(group => group.selling_plans || []);
    const monthlyPlans = new Set(planList.filter(plan => {
      const option = (plan.options || []).find(option => option.name === 'config');
      try {
        const policy = JSON.parse(option?.value || 'null');
        return policy?.delivery?.interval === 'MONTH' && Number(policy.delivery.frequency) === 1;
      } catch { return false; }
    }).map(plan => String(plan.id)));
    let currentCart = null;
    let syncAppCart = () => {};
    const gifts = config.gifts || [];
    const giftIds = new Set(gifts.map(gift => String(gift.id)));
    const eligibleIds = new Set(variants.slice(1, 3).map(variant => String(variant.id)));
    let giftTimer;
    let giftSyncing = false;
    let cartSignature = '';
    const giftFor = item => gifts.find(gift => String(gift.id) === String(item?.variant_id || item?.id));
    function giftItems(parent, parentKey) {
      return gifts.map(gift => ({ id: gift.id, quantity: parent.quantity, ...(parentKey ? { parent_line_key: parentKey } : { parent_id: parent.id }), properties: { _hp_bundle_gift: 'true' } }));
    }
    async function reconcileGifts(cart) {
      if (!gifts.length) return cart;
      const parents = cart.items.filter(item => eligibleIds.has(String(item.variant_id || item.id)));
      const updates = {};
      const additions = [];
      for (const item of cart.items.filter(item => giftIds.has(String(item.variant_id || item.id)) && item.properties?._hp_bundle_gift === 'true')) {
        const parent = parents.find(parent => parent.key === item.parent_relationship?.parent_key);
        if (!parent || item.quantity !== parent.quantity) updates[item.key] = parent?.quantity || 0;
      }
      for (const parent of parents) {
        for (const gift of giftItems(parent, parent.key)) {
          const matching = cart.items.find(item => String(item.variant_id || item.id) === String(gift.id) && item.parent_relationship?.parent_key === parent.key);
          if (!matching) additions.push(gift);
        }
      }
      if (Object.keys(updates).length) cart = await api('cart/update.js', { updates });
      if (additions.length) { await api('cart/add.js', { items: additions }); cart = await api('cart.js'); }
      if (Object.keys(updates).length || additions.length) await window.kachingCartApi?.openCart?.();
      return cart;
    }
    function scheduleGiftSync() {
      if (!gifts.length || giftSyncing) return;
      clearTimeout(giftTimer);
      giftTimer = setTimeout(async () => {
        giftSyncing = true;
        try { await renderCart(await reconcileGifts(await api('cart.js'))); }
        catch (error) { message.textContent = error.message; }
        finally { giftSyncing = false; }
      }, 180);
    }
    async function openCart() {
      if (window.kachingCartApi?.openCart) { await window.kachingCartApi.openCart(); return; }
      if (document.getElementById('kaching-cart')) {
        await new Promise(resolve => {
          const started = Date.now();
          const wait = setInterval(() => { if (window.kachingCartApi?.openCart || Date.now() - started > 1500) { clearInterval(wait); resolve(); } }, 50);
        });
        if (window.kachingCartApi?.openCart) { await window.kachingCartApi.openCart(); return; }
      }
      openDialog($('#hp-cart'));
    }
    function purchaseType(planId, planName) {
      if (!planId) return { type: 'one-time', text: labels.oneTimePurchase };
      if (monthlyPlans.has(String(planId))) return { type: 'subscription', text: labels.monthlyPurchase };
      return { type: 'subscription', text: planName ? `${labels.subscriptionPurchase} — ${planName}` : labels.subscriptionPurchase };
    }
    function setPurchaseLabel(element, purchase) {
      if (element.dataset.purchaseType !== purchase.type) element.dataset.purchaseType = purchase.type;
      if (element.textContent !== purchase.text) element.textContent = purchase.text;
    }
    let lastFocus;
    function openDialog(dialog) { if (dialog.id === 'hp-cart' && document.querySelector('#kaching-cart.active')) return; lastFocus = document.activeElement; dialog.showModal(); }
    $$('[data-open]').forEach(button => button.addEventListener('click', async () => { const dialog = document.getElementById(button.dataset.open); if (dialog.id === 'hp-cart') { await renderCart(); await openCart(); } else openDialog(dialog); }));
    $$('dialog').forEach(dialog => {
      dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', () => lastFocus?.focus());
      dialog.addEventListener('click', event => { const rect = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close(); });
      dialog.querySelectorAll('nav a').forEach(a => a.addEventListener('click', () => dialog.close()));
    });
    function connectAppCart() {
      const appCart = document.getElementById('kaching-cart');
      if (!appCart) return false;
      const observed = { attributes: true, attributeFilter: ['aria-label', 'class', 'href', 'data-line-key', 'data-has-selling-plan'], childList: true, subtree: true };
      const observer = new MutationObserver(() => sync());
      const sync = () => {
        observer.disconnect();
        const count = appCart.getAttribute('aria-label')?.match(/(\d+)\s*$/);
        if (count) $('.hp-cart-count').textContent = count[1];
        if (appCart.classList.contains('active') && $('#hp-cart').open) $('#hp-cart').close();
        const signature = [...appCart.querySelectorAll('.kaching-cart-item[data-line-key]')].map(row => `${row.dataset.lineKey}:${row.querySelector('a.kaching-cart-item__title')?.getAttribute('href')}:${row.querySelector('input[type=number]')?.value}`).join('|');
        if (signature !== cartSignature) { cartSignature = signature; scheduleGiftSync(); }
        for (const row of appCart.querySelectorAll('.kaching-cart-item[data-line-key]')) {
          const info = row.querySelector('.kaching-cart-item__info');
          const link = row.querySelector('a.kaching-cart-item__title');
          if (!info || !link) continue;
          const item = currentCart?.items.find(item => item.key === row.dataset.lineKey);
          const url = new URL(link.getAttribute('href'), window.location.origin);
          const planId = item ? item.selling_plan_allocation?.selling_plan?.id : row.dataset.hasSellingPlan === 'true' ? url.searchParams.get('selling_plan') : null;
          const planName = item?.selling_plan_allocation?.selling_plan?.name || planList.find(plan => String(plan.id) === String(planId))?.name;
          let badge = info.querySelector('.hp-cart-purchase-type');
          if (!badge) {
            badge = document.createElement('p');
            badge.className = 'hp-cart-purchase-type';
            link.after(badge);
          }
          if (link.nextElementSibling !== badge) link.after(badge);
          const gift = giftFor(item) || gifts.find(gift => url.searchParams.get('variant') === String(gift.id));
          if (gift) {
            setPurchaseLabel(badge, { type: 'gift', text: labels.freeGift });
          } else setPurchaseLabel(badge, purchaseType(planId, planName));
        }
        observer.observe(appCart, observed);
      };
      syncAppCart = sync;
      sync();
      return true;
    }
    if (!connectAppCart()) {
      const mount = new MutationObserver(() => { if (connectAppCart()) mount.disconnect(); });
      mount.observe(document.body, { childList: true, subtree: true });
    }
    async function api(path, payload) {
      const response = await fetch(shopRoot + path, payload ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) } : { headers: { 'Accept': 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : labels.error);
      return result;
    }
    async function renderCart(cart) {
      try {
        cart ||= await api('cart.js');
        currentCart = cart;
        syncAppCart();
        $('.hp-cart-count').textContent = cart.item_count;
        const container = $('[data-cart-body]'); container.replaceChildren();
        if (!cart.items.length) { const empty = document.createElement('p'); empty.textContent = labels.empty; container.append(empty); }
        for (const item of cart.items) {
          const row = document.createElement('div'); row.className = 'hp-cart-line';
          if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.product_title; row.append(image); }
          const info = document.createElement('div');
          const title = document.createElement('p'); title.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''); info.append(title);
          const price = document.createElement('p');
          if (item.original_line_price > item.final_line_price) { const original = document.createElement('s'); original.textContent = money(item.original_line_price); price.append(original, ' '); }
          price.append(giftFor(item) && item.final_line_price === 0 ? labels.free : money(item.final_line_price)); info.append(price);
          const purchase = document.createElement('p'); purchase.className = 'hp-cart-purchase-type'; setPurchaseLabel(purchase, giftFor(item) ? { type: 'gift', text: labels.freeGift } : purchaseType(item.selling_plan_allocation?.selling_plan?.id, item.selling_plan_allocation?.selling_plan?.name)); info.append(purchase);
          const quantity = document.createElement('select'); quantity.setAttribute('aria-label', item.product_title + ' quantity');
          for (let i = 1; i <= Math.max(10, item.quantity); i++) { const option = document.createElement('option'); option.value = i; option.textContent = i; option.selected = i === item.quantity; quantity.append(option); }
          quantity.addEventListener('change', async () => { quantity.disabled = true; try { await renderCart(await reconcileGifts(await api('cart/change.js', { id: item.key, quantity: Number(quantity.value) }))); } catch (error) { quantity.disabled = false; message.textContent = error.message; } });
          const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = labels.remove;
          remove.addEventListener('click', async () => { remove.disabled = true; try { await renderCart(await reconcileGifts(await api('cart/change.js', { id: item.key, quantity: 0 }))); } catch (error) { remove.disabled = false; message.textContent = error.message; } });
          info.append(quantity, remove); row.append(info); container.append(row);
        }
        $('[data-cart-subtotal]').textContent = money(cart.total_price);
        $('.hp-cart-footer').hidden = !cart.items.length;
      } catch (error) { $('[data-cart-body]').textContent = error.message; }
    }
    $('.hp-product-form').addEventListener('submit', async event => {
      event.preventDefault();
      const variant = variants[selectedIndex];
      if (config.preview || !variant || !variant.available) { message.textContent = labels.draft; return; }
      const button = $('[data-add]'); button.disabled = true; button.setAttribute('aria-busy', 'true'); message.textContent = '';
      const item = { id: variant.id, quantity: 1 }; if (sellingPlan) item.selling_plan = sellingPlan;
      try {
        if (selectedIndex > 0 && (gifts.length !== 2 || gifts.some(gift => !gift.available))) throw new Error(labels.giftsUnavailable);
        const items = selectedIndex > 0 ? [item, ...giftItems(item)] : [item];
        await api('cart/add.js', { items });
        await renderCart();
        await openCart();
      }
      catch (error) { message.textContent = error.message; }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
    const expertGrid = $('.hp-expert-grid');
    $('[data-expert-prev]').addEventListener('click', () => expertGrid.scrollBy({ left: -expertGrid.clientWidth * .95, behavior: reduced ? 'instant' : 'smooth' }));
    $('[data-expert-next]').addEventListener('click', () => expertGrid.scrollBy({ left: expertGrid.clientWidth * .95, behavior: reduced ? 'instant' : 'smooth' }));
    $$('[data-review-photo]').forEach(button => button.addEventListener('click', () => { const modal = $('#hp-photo-dialog'); modal.querySelector('img').src = button.querySelector('img').src; openDialog(modal); }));
    let reverse = false;
    $('[data-review-sort]').addEventListener('click', () => { reverse = !reverse; const list = $('.hp-review-list'); [...list.children].reverse().forEach(row => list.append(row)); });
    $('[data-review-filter]').addEventListener('click', () => { $('.hp-review-message').textContent = labels.reviewPage; });
    $$('[data-review-page]').forEach(button => button.addEventListener('click', () => { if (button.dataset.reviewPage !== '1') $('.hp-review-message').textContent = labels.reviewPage; else { $('.hp-review-message').textContent = ''; $('#hp-reviews').scrollIntoView(); } }));
  }
  document.querySelectorAll('.hp-page').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.hp-page')));
})();

